import { DeleteToneDto } from '../../../dto/deletetone/deletetonedto';
import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface DeleteToneRequest extends APIRequest
{
    getDeleteToneRequest(): DeleteToneDto;
}

export class DeleteToneRequestImpl extends APIRequestDtoImpl implements DeleteToneRequest
{
    constructor(private deleteToneData: DeleteToneDto)
    {
        super();
    }

    getDeleteToneRequest(): DeleteToneDto
    {
        return this.deleteToneData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/tune/deletetone/deletetonerequest.tsx